import React from 'react';
import {
  Instagram as InstagramIcon,
  Facebook as FacebookIcon,
  LinkedIn as LinkedInIcon,
  YouTube as YouTubeIcon,
  Pinterest as PinterestIcon,
  Email as EmailIcon,
  Article as BlogIcon,
  MusicVideo as TikTokIcon,
} from '@mui/icons-material';
import { XIcon } from '../../icons/XIcon';

interface PlatformIconProps {
  platformName: string;
  size?: number;
  marginRight?: number;
}

export const PlatformIcon: React.FC<PlatformIconProps> = ({
  platformName,
  size = 28,
  marginRight = 1.5,
}) => {
  const iconProps = { sx: { fontSize: size, mr: marginRight } };
  
  switch (platformName.toLowerCase()) {
    case 'instagram':
      return <InstagramIcon {...iconProps} />;
    case 'facebook':
      return <FacebookIcon {...iconProps} />;
    case 'twitter':
    case 'x':
      return <XIcon {...iconProps} />;
    case 'linkedin':
      return <LinkedInIcon {...iconProps} />;
    case 'youtube':
      return <YouTubeIcon {...iconProps} />;
    case 'pinterest':
      return <PinterestIcon {...iconProps} />;
    case 'email':
      return <EmailIcon {...iconProps} />;
    case 'blog':
      return <BlogIcon {...iconProps} />;
    case 'tiktok':
      return <TikTokIcon {...iconProps} />;
    default:
      return <BlogIcon {...iconProps} />;
  }
};

